import axios from 'axios';

import config from '../../config/config';

export default async function defaultQueryFn({queryKey}) {
  const { data } = await axios.get(`${config.baseUrl}${queryKey[0]}`);
  return data;
}